import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../icons/Icon.vue.js';

var script = defineComponent({
    name: 'PromotionHubButton',
    components: {
        Icon: __vue_component__,
    },
});

export default script;
